import { useGetTheme } from "@/hooks/use-theme";

import AppLogo from "@/assets/icons/app-logo-black.svg";
import AppLogoWhite from "@/assets/icons/app-logo-white.svg";

export const useLogo = (variant: "white" | "black" | "auto" = "auto") => {
  const themeUsed = useGetTheme();

  if (variant === "white") {
    return AppLogoWhite;
  } else if (variant === "black") {
    return AppLogo;
  } else {
    if (themeUsed === "dark") {
      return AppLogoWhite;
    } else if (themeUsed === "light") {
      return AppLogo;
    } else {
      const prefersDarkScheme = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      return prefersDarkScheme ? AppLogoWhite : AppLogo;
    }
  }
};
